import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _class;
import { fetch, fetchOk } from '@atlassian/mpac-fetch-wrapper';
import URL from 'url-parse';
import { instanceToModule, returnsPromise } from './connect/Util';
const getStargateMarketplaceUrl = (siteBaseUrl, stargatePath) => "".concat(siteBaseUrl, "/gateway/api/marketplace").concat(stargatePath);
let StargateMarketplaceApi = (_class = class StargateMarketplaceApi {
  constructor(config) {
    _defineProperty(this, "config", void 0);
    _defineProperty(this, "siteBaseUrl", void 0);
    this.config = config;
    // Stargate APIs are available only on the base url excluding wiki
    this.siteBaseUrl = new URL(this.config.baseUrl).origin;
  }
  async fetchOk(url, options) {
    let response;
    try {
      response = await fetchOk(getStargateMarketplaceUrl(this.siteBaseUrl, url), options);
      const responseJson = await response.json();
      return Promise.resolve(responseJson);
    } catch (error) {
      if (response && response.ok) {
        return Promise.resolve({
          status: response.status
        });
      }
      return Promise.reject(error);
    }
  }
  async fetch(url, options) {
    return fetch(getStargateMarketplaceUrl(this.siteBaseUrl, url), options);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "fetchOk", [returnsPromise], Object.getOwnPropertyDescriptor(_class.prototype, "fetchOk"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "fetch", [returnsPromise], Object.getOwnPropertyDescriptor(_class.prototype, "fetch"), _class.prototype)), _class);
export default (config => instanceToModule(new StargateMarketplaceApi(config)));